import * as appActionTypes from "../../actions/AppState/type";
import { GET_TOPIC_DONE } from "../../actions/topics";
import { GET_SUBTOPIC_DONE } from "../../actions/subtopics";
import { readAllWorkspaces } from "../../../utils/workspaceView";

// The selected topic/subtopic is a copy of the list item it was picked from:
// when a reloaded list renames it, rename the copy too (the header and new
// messages use it). Returns the same object when nothing changed.
const withFreshName = (selected, list) => {
  if (!selected?.id || !Array.isArray(list)) return selected;
  const fresh = list.find((item) => item?.id === selected.id);
  return fresh?.name && fresh.name !== selected.name ? { ...selected, name: fresh.name } : selected;
};

const initState = {
  allWorkspaces: readAllWorkspaces(),
  pubnub: null,
  selectedGroupData: null,
  selectedTopicData: null,
  selectedThreadData: null,
  selectedTopicToSaveMsg: null,
  selectedSubtopicData: null,
  selectedSubtopicToSaveMsg: null,
  showStarMessage: false,
  isAiScreenActive: false,
  isChangeTopicOpen: false,
  isChangeSubtopicOpen: false,
  isScrollToBottom: true,
  isSwitchAccountRefresh: false,
  isThreadScrollToBottom: null,
  toggleSetPubTokenState: false,
  serviceType:0,
  postEditPreviewData: {},

};

export const appReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_TOPIC_DONE: {
      const selectedTopicData = withFreshName(state.selectedTopicData, action?.payload);
      const selectedTopicToSaveMsg = withFreshName(state.selectedTopicToSaveMsg, action?.payload);
      if (selectedTopicData === state.selectedTopicData && selectedTopicToSaveMsg === state.selectedTopicToSaveMsg) return state;
      return { ...state, selectedTopicData, selectedTopicToSaveMsg };
    }
    case GET_SUBTOPIC_DONE: {
      const selectedSubtopicData = withFreshName(state.selectedSubtopicData, action?.payload);
      const selectedSubtopicToSaveMsg = withFreshName(state.selectedSubtopicToSaveMsg, action?.payload);
      if (selectedSubtopicData === state.selectedSubtopicData && selectedSubtopicToSaveMsg === state.selectedSubtopicToSaveMsg) return state;
      return { ...state, selectedSubtopicData, selectedSubtopicToSaveMsg };
    }
    case appActionTypes.TOGGLE_UPDATE_PUBNUB_TOKEN:
      return {
        ...state,
        toggleSetPubTokenState: action?.payload,
      };
    case appActionTypes.SET_SCROLL_TO_BOTTOM:
      return {
        ...state,
        isScrollToBottom: action?.payload,
      };
    case appActionTypes.POST_PREVIEW_OR_EDIT_DATA:
      return {
        ...state,
        postEditPreviewData: action?.payload,
      };
    case appActionTypes.SET_THREAD_SCROLL_TO_BOTTOM:
      return {
        ...state,
        isThreadScrollToBottom: action?.payload,
      };
    case appActionTypes.SET_SELECTED_GROUP_DATA:
      return {
        ...state,
        selectedGroupData: action?.payload,
      };
    case appActionTypes.SET_SELECTED_TOPIC_DATA:
      return {
        ...state,
        selectedTopicData: action?.payload,
      };
    case appActionTypes.SET_SELECTED_THREAD_DATA:
      return {
        ...state,
        selectedThreadData: action?.payload,
      };
    case appActionTypes.TOPIC_TO_SAVE_MESSAGE:
      return {
        ...state,
        selectedTopicToSaveMsg: action?.payload,
      };
    case appActionTypes.CHANGE_TOPIC_INITIATED:
      return {
        ...state,
        isChangeTopicOpen: action?.payload,
      };
    case appActionTypes.SET_SELECTED_SUBTOPIC_DATA:
      return {
        ...state,
        selectedSubtopicData: action?.payload,
      };
    case appActionTypes.SUBTOPIC_TO_SAVE_MESSAGE:
      return {
        ...state,
        selectedSubtopicToSaveMsg: action?.payload,
      };
    case appActionTypes.CHANGE_SUBTOPIC_INITIATED:
      return {
        ...state,
        isChangeSubtopicOpen: action?.payload,
      };
    case appActionTypes.SET_SHOW_STARMESSAGE_SCREEN:
      return {
        ...state,
        showStarMessage: action?.payload,
      };
    case appActionTypes.SET_SHOW_AI_SCREEN:
      return {
        ...state,
        isAiScreenActive: action?.payload,
      };
      case appActionTypes.SET_SERVICETYPE_POST:
        return {
          ...state,
          serviceType: action?.payload,
        };
    case appActionTypes.SET_SHOW_AI_HISTOPRY_SCREEN:
      return {};
    case appActionTypes.SET_SHOW_STARHISTOPRY_SCREEN:
      return {};

    case appActionTypes.SET_ALL_WORKSPACES:
      return {
        ...state,
        allWorkspaces: action?.payload,
      };

    case appActionTypes.SWITCH_ACCOUNT_SHOULD_REFRESH:
      return {
        ...state,
        isSwitchAccountRefresh: action?.payload,
      };

    default:
      return state;
  }
};
